export default __webpack_public_path__ + "static/media/file.793819ef.svg";